import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import Colors from "styles/colors";
import { StyledProgressBarComponent } from "./progressbar-component.scss";
class ProgressBarComponent extends PureComponent {
    render() {
        const { forceProgressbarDone, duration, progressbarColor, enabled } = this.props;
        return /*#__PURE__*/ _jsx(StyledProgressBarComponent, {
            className: "progressbar",
            children: /*#__PURE__*/ _jsx("div", {
                className: classnames({
                    "progressbar-fill": enabled,
                    "progressbar-start-animation": !forceProgressbarDone,
                    "progressbar-stop-animation": forceProgressbarDone || !enabled
                }),
                style: {
                    animationDuration: `${duration}ms`,
                    backgroundColor: Colors[progressbarColor]
                }
            })
        });
    }
}
export { ProgressBarComponent as default };
